import ArrowDropUpDown from "components/icons/ArrowDropUpDown";

export const SortArrow = ({ arrow, active = false }) => {
  return (
    <div className={`ml-1 opacity-40 ${active ? '!opacity-100' : ''}`} data-testid={`sort-arrow-${arrow}`}>
      <ArrowDropUpDown
        className={'h-[9px] w-[9px]'}
        direction={arrow}
      />
    </div>
  );
};
